module.exports = ['$scope', '$state', '$phoneModal', 'User', '$translate', '$utils', '$ionicPopup', 'signatureService', '$sce',
  function ($scope, $state, $phoneModal, User, $translate, $utils, $ionicPopup, signatureService, $sce) {
    (function initSignatureModule() {
      $scope.isLoading = true
      /** 获取当前用户的签名档 */
      /** get a list of signature belonged to current user */
      signatureService.getSignatures().then(function (data) {
        if (data.code === 'S_OK' && data.var) {
          $scope.signatureList = data.var
          $scope.isLoading = false
        }
      }, function (msg) {
        console.log(msg)
      })
    })()

    // 更新签名档信息
    const updateSignatures = function (items, message, callback) {
      signatureService.updateSignatures({
        items: items
      }).then(function (data) {
        if (data.code === 'S_OK') {
          $utils.$notify.set({ message: message })
          callback && callback()
        }
      }, function (msg) {
        console.log(msg)
      })
    }

    $scope.chooseSignature = function (id) {
      /** calling API */
      updateSignatures(
        [{ id: id, isDefault: true }],
        $translate.instant('TIPS.SETTING_SUCCESS'),
        function () {
          /** update scope */
          $scope.signatureList.forEach(function (obj) {
            obj.isDefault = obj.id === id
          })
        }
      )
    }

    /** 取消默认签名档 */
    /** cancel the default signature */
    $scope.cancelSignature = function () {
      const items = []
      $scope.signatureList.forEach(function (obj) {
        items.push({
          id: obj.id,
          isDefault: false
        })
      })

      updateSignatures(
        items,
        $translate.instant('TIPS.CANCEL_SUCCESS'),
        function () {
          /** update scope */
          $scope.signatureList.forEach(function (obj) {
            obj.isDefault = false
          })
        }
      )
    }

    /** 显示指定签名档的内容 */
    /** show the detail of certain signature */
    $scope.showSignatureDetail = function (id) {
      /** search list */
      $scope.signatureList.forEach(function (obj) {
        if (obj.id === id) {
          const $newScope = $scope.$new()

          $newScope.content = !obj.isHtml ? obj.content.replace(/\n/g, '<br />') : $sce.trustAsHtml($utils.$html.filterXSS(obj.content))
          $newScope.detailModal = $phoneModal.fromTemplate(require('views/setting/signature/detail.html'), {
            scope: $newScope,
            animation: 'slide-in-right'
          })

          $newScope.closeModal = function () {
            $newScope.detailModal.remove()
          }

          $newScope.detailModal.show()
        }
      })
    }
  }]



// WEBPACK FOOTER //
// ./src/js/setting/signature/signatureCtrl.js